// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../node_modules/rescript/lib/es6/string.js";
import * as Js_string from "../../../../node_modules/rescript/lib/es6/js_string.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_format from "../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_string from "../../../../node_modules/rescript/lib/es6/caml_string.js";

function lastDigit(str) {
  return Caml_format.int_of_string("0x" + $$String.make(1, Caml_string.get(str, str.length - 1 | 0)));
}

function isIDMatched(id, upper, lower) {
  var match = id.length;
  if (match === 0) {
    return false;
  }
  var lastNum = lastDigit(id);
  if (lastNum < upper) {
    return lastNum >= lower;
  } else {
    return false;
  }
}

function isMobileInInternalUsersList(mobile, internal_user_list) {
  if (mobile === undefined) {
    return false;
  }
  var mobArray = Js_string.split(",", internal_user_list);
  return Belt_Array.reduce(mobArray, false, (function (acc, item) {
                if (acc) {
                  return true;
                } else {
                  return item === mobile;
                }
              }));
}

function isMobileNumberEndingInTwoDigitRange(mobile, rangeStart, rangeEnd) {
  if (!(mobile !== "" && rangeStart !== "" && rangeEnd !== "" && mobile.length >= 2)) {
    return false;
  }
  var endIndex = mobile.length - 1 | 0;
  var lastTwoDigits = $$String.sub(mobile, endIndex - 1 | 0, 2);
  var lastTwoDigitsNum = Caml_format.int_of_string(lastTwoDigits);
  var startDigit = Caml_format.int_of_string(rangeStart);
  var endDigit = Caml_format.int_of_string(rangeEnd);
  if (lastTwoDigitsNum >= startDigit) {
    return lastTwoDigitsNum <= endDigit;
  } else {
    return false;
  }
}

export {
  lastDigit ,
  isIDMatched ,
  isMobileInInternalUsersList ,
  isMobileNumberEndingInTwoDigitRange ,
}
/* No side effect */
